import React from "react";
import { Overlay, Wrapper, Header } from "./styled";
import types from "./types";
import { injectIntl } from "react-intl";

const SettingsModal = ({
  isOpen,
  onClose,
  handleSave,
  initialData,
  rowIdx,
  type,
  intl,
}) => {
  const Settings = types[type];

  return isOpen ? (
    <Overlay>
      <Wrapper className="sp-inputtable-admin-row-settings-modal">
        <Header>{`${intl.formatMessage({ id: "InputTable.rowSettings" })}: ${
          rowIdx + 1
        }`}</Header>
        <Settings
          data={initialData}
          rowIdx={rowIdx}
          handleSave={handleSave}
          onClose={onClose}
        />
      </Wrapper>
    </Overlay>
  ) : null;
};

export default injectIntl(SettingsModal);
